// ダイアログ・メニュー（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { txt } from './text.js';
import { $ } from './util.js';

// openModalNode の設定（下の説明）
export interface ModalOptions { light?: boolean; onClose?: () => void; cls?: string; closeLabel?: string }

// ---- ダイアログ・メニュー ----
export function openModal(html: string) { $('modalBody').innerHTML = html; $('modal').hidden = false; }
export function openModalNode(node: Node, extras?: HTMLElement[], opts?: ModalOptions) {
  $('modalBody').textContent = '';
  $('modalBody').appendChild(node);
  $('modal').classList.toggle('light', !!(opts && opts.light));
  S.modalOnClose = (opts && opts.onClose) || null;
  if (S.modalCls) $('modal').classList.remove(S.modalCls);
  S.modalCls = (opts && opts.cls) || '';
  if (S.modalCls) $('modal').classList.add(S.modalCls);
  $('modalClose').textContent = (opts && opts.closeLabel) || txt('close');
  (extras || []).forEach((b) => { b.classList.add('extra'); $('modalClose').before(b); });
  $('modal').hidden = false;
}
export function closeModal() {
  const after = S.modalOnClose;
  S.modalOnClose = null;
  $('modal').hidden = true;
  $('modal').classList.remove('light');
  if (S.modalCls) { $('modal').classList.remove(S.modalCls); S.modalCls = ''; }
  $('modalClose').textContent = txt('close');
  $('modalBody').textContent = '';
  document.querySelectorAll('.sheet-foot .extra').forEach((b) => { b.remove(); });
  if (after) after();
}
export function toggleMenu(open?: boolean | null) {
  const menu = $('menu');
  if (open == null) open = menu.hidden as boolean;
  menu.hidden = !open;
  $('btnMenu').setAttribute('aria-expanded', open ? 'true' : 'false');
}
